<template>
  <CustomUpdateDialog
    okTitle="بله"
    dialogTitle="ویرایش تعداد سوال مورد نیاز برای مشاهده کامل لیدربرد"
    dialogId="edit-leaderboard-question-limit-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="updateLeaderboardQuestionLimit"
  >
    <div class="w-100 d-flex align-items-center" style="gap: 2rem">
      <p>
        آیا از تغییر تعداد سوال مورد نیاز برای مشاهده کامل لیدربرد به
        <span style="font-weight: bolder">
          {{ newLimitCount }}
          سوال
        </span>
        اطمینان دارید؟
      </p>
    </div>
  </CustomUpdateDialog>
</template>
<script>
export default {
  props: {
    isOkButtonDisabled: {
      type: Boolean,
      default: false,
    },
    newLimitCount: {
      type: [String, Number],
    },
  },
  emits: ["updateLeaderboardQuestionLimit"],
  methods: {
    updateLeaderboardQuestionLimit() {
      this.$emit("updateLeaderboardQuestionLimit");
    },
  },
  components: {
    CustomUpdateDialog,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
</script>
